import Table from 'components/table/table';
import MediaQuery from 'react-responsive';
import { useEffect } from 'react';
import { useOutletContext, useNavigate } from 'react-router-dom';
import EmptyState from '../../../components/EmptyState/EmptyState';
import TimeSheetMobileCard from '../../../components/card/MobileListCard/TimeSheetMobileCard';
import UseContext from '../../../hooks/useContext';

const MobileCardSkeleton = () => (
  <div className="flex flex-col gap-3 p-4 animate-pulse">
    {[1, 2, 3, 4, 5].map((i) => (
      <div key={i} className="bg-white rounded-xl border border-gray-200 p-4">
        <div className="flex justify-between items-start mb-3">
          <div className="h-5 bg-gray-200 rounded w-3/4" />
          <div className="h-6 bg-gray-100 rounded-md w-16" />
        </div>
        <div className="flex justify-between items-center gap-4">
          <div className="h-4 bg-gray-100 rounded w-24" />
          <div className="h-4 bg-gray-100 rounded w-28" />
          <div className="h-4 bg-gray-100 rounded w-32" />
        </div>
      </div>
    ))}
  </div>
);

const TableSkeleton = ({ titles }) => (
  <div className="flex-1 overflow-y-auto">
    <table className="animate-pulse w-full">
      <tbody>
        {[1, 2, 3, 4, 5].map((i) => (
          <tr key={i}>
            {titles.map((_, idx) => (
              <td key={idx} className={`py-7 ${idx === 0 ? 'pl-4' : ''} ${idx === titles.length - 1 ? 'pr-3' : 'px-2'}`}>
                <div className="h-2 bg-gray-200 rounded" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const BASE_TITLES = [
  'N° DE RELEVÉ',
  'RAISON SOCIALE',
  'POSTE',
  'N° DE MISSION',
  'INTÉRIMAIRE',
  'PÉRIODE',
];

/**
 * @param {string} status - API status filter ('0', '1', '2', '3')
 * @param {string} emptyStateType - EmptyState type identifier
 * @param {boolean} showStatusColumn - Whether to add 'STATUS' column
 */
const TimeSheetTabContent = ({ status, emptyStateType, showStatusColumn = false }) => {
  const {
    timeSheetsToDisplay, currentPage, setCurrentPage,
    totalPages, countPerPage, countTotal, isWaiting, setStatus,
  } = useOutletContext();
  const { setObjID, setContent } = UseContext();
  const navigate = useNavigate();

  useEffect(() => { setStatus(status); }, [setStatus, status]);

  const handleTimeSheetClick = (item) => {
    setObjID(item._id);
    setContent({
      title: item.title,
      idMission: item.id_mission_reel,
      nameCompany: item.name_commercial,
    });
    navigate(`../ficheHour/${item._id}`);
  };

  const titles = showStatusColumn ? [...BASE_TITLES, 'STATUS'] : BASE_TITLES;

  if (isWaiting) {
    return (
      <div className="flex flex-col h-full">
        <MediaQuery minWidth={768}><TableSkeleton titles={titles} /></MediaQuery>
        <MediaQuery maxWidth={767}><MobileCardSkeleton /></MediaQuery>
      </div>
    );
  }

  if (!timeSheetsToDisplay?.length) {
    return (
      <div className="flex-1 flex justify-center p-3">
        <EmptyState type={emptyStateType} />
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <MediaQuery minWidth={768}>
        <Table
          champsBody={timeSheetsToDisplay}
          champsHeader={titles}
          currentPage={currentPage}
          countPerPage={countPerPage}
          countTotal={countTotal}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
        />
      </MediaQuery>
      <MediaQuery maxWidth={767}>
        <div className="flex flex-col gap-3 p-4">
          {timeSheetsToDisplay.map((item) => (
            <TimeSheetMobileCard key={item._id} item={item} onClick={handleTimeSheetClick} />
          ))}
        </div>
      </MediaQuery>
    </div>
  );
};

export default TimeSheetTabContent;
